export const FILE_UPLOAD_ALLOWED_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'] as const;
export const FILE_UPLOAD_ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.gif'] as const;

export const FILE_UPLOAD_MAX_SIZE_MB = 5;
export const FILE_UPLOAD_MAX_SIZE_BYTES = FILE_UPLOAD_MAX_SIZE_MB * 1024 * 1024;

export const FILE_UPLOAD_MAX_FILES = 5;

export const PROFILE_IMAGE_FILE_NAME = 'profile.png';

export const getPublicProfileImageFolder = (expertId: string): string => `/${expertId}/profile`;
export const getPublicProfileImageSrc = (expertId: string, fileKey = ''): string => `/${expertId}/profile/${fileKey}`;
